import React, { useEffect, useMemo, useState } from 'react';
import { Button, message, Modal, Tag } from 'antd';
import scss from 'components/top/AiDrawer/AiDrawer.scss';
import { ze } from 'utils/zhEn';
import ThinkingIcon from 'svg/v2/newcs_aiassistant_deepthinking.svg';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

const AiReasoningStatusBlock = (props) => {
  const {
    isReasoning,
    isCollapsed,
    onChangeCollapsed = (v) => {},
  } = props;

  let text;
  if (isReasoning) {
    text = ze('思考中', 'Reasoning');
  } else {
    text = ze('已完成思考', 'Reasoning Result');
  }

  const showCollapseButton = !isReasoning;

  const collapseButtonProps = {
    onClick() {
      onChangeCollapsed(!isCollapsed);
    },
  };
  const collapseButton = isCollapsed
    ? <DownOutlined {...collapseButtonProps}/>
    : <UpOutlined {...collapseButtonProps}/>;

  return <div
    className={scss.reasoningStatus}
  >
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <ThinkingIcon style={{
        marginRight: '4px',
        transform: 'scale(0.75)',
        transformOrigin: 'center'  // 从中心点缩放
      }}/>
      <div style={{ marginRight: '4px', userSelect: 'none' }}>{ text }</div>
      { showCollapseButton && collapseButton }
    </div>
  </div>
};

export default AiReasoningStatusBlock;
